import React from "react";

import "./index.scss";

const SortIcon = ({ sortOrder }) => (
  <svg id="SortIcon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="sort-icon">
    <rect id="Margin" className="cls-1" width="32" height="32" />
    <g id="sort-icon" data-name="SortIcon" className={sortOrder}>
      <path
        id="Path_8644"
        data-name="Path 8644"
        className="cls-2"
        d="M0,9.782,4.522,5.261,0,.739.74,0,6,5.261.74,10.521Z"
        transform="translate(11 11) rotate(-90)"
      />
      <path
        id="Path_8647"
        data-name="Path 8647"
        className="cls-3"
        d="M0,9.782,4.522,5.261,0,.739.74,0,6,5.261.74,10.521Z"
        transform="translate(21.021 20.5) rotate(90)"
      />
    </g>
  </svg>
);

export default SortIcon;
